// extracted by mini-css-extract-plugin
module.exports = {"ratingCategory":"RatingCategory_ratingCategory__nqxzz","categoryRating":"RatingCategory_categoryRating__FfMYa","categoryLabel":"RatingCategory_categoryLabel__SDf7U"};